"use client";

export { ErrorPage as default } from "~/features/error";
